import React from 'react';
import Icon from '../../../../components/AppIcon';
import Logo from 'assets/JustBooked_Curve.png'

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <div className="flex items-center justify-center mb-0 mt-0">
        {/* <div className="flex items-center justify-center">
          <img src={Logo} alt="Company Logo" />
        </div> */}
        <div className='bg-cover bg-center w-full h-28' style={{ backgroundImage: `url(${Logo})` }}></div>
      </div>

      {/* Brand Name */}
      {/* <h1 className="text-2xl font-bold text-foreground mb-2">
        CarWash Manager
      </h1> */}

      {/* Subtitle */}
      {/* <p className="text-muted-foreground text-sm">
        Sign in to manage your car wash business
      </p> */}
    </div>
  );
};

export default LoginHeader;